import React, { ReactElement } from 'react';
import { useTranslations } from '../../../../translations';
import { IconAttentionComponent } from '../../../../icons';
import {
  CustomersSubscriptionPopup,
  CustomersSubscriptionPopupSubtitle,
  CustomersSubscriptionPopupTitle,
} from '../../customersSubscriptionPopup.styled';

export const Unpaid = (): ReactElement => {
  const translations = useTranslations();
  return (
    <CustomersSubscriptionPopup>
      <IconAttentionComponent width={48} height={48} fillColor="#201926" />
      <CustomersSubscriptionPopupTitle>
        {translations.kcell_subscription_is_activating}
      </CustomersSubscriptionPopupTitle>
      <CustomersSubscriptionPopupSubtitle
        dangerouslySetInnerHTML={{
          __html: translations.try_again_later_or_contact_kcell,
        }}
      />
    </CustomersSubscriptionPopup>
  );
};
